import React from 'react';
import DashboardHeader from '../../layouts/dashboard_header';
import SideMenu from '../../layouts/dashboard_menu';
import DashboardFooter from '../../layouts/dashboard_footer';
import '../ModernDashboard.css';

type Props = {
    title: string;
    subtitle: string;
    loading?: boolean;
    error?: string | null;
    children: React.ReactNode;
};

/** Shared chrome + loading/error states for all six dashboards
 * (execution_strategy_activity_tracker.md, Phase 4) so they read as one
 * system rather than six separately-built pages. */
const DashboardShell: React.FC<Props> = ({title, subtitle, loading, error, children}) => (
    <>
        <DashboardHeader/>
        <SideMenu/>
        <div className="vertical-overlay"/>
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid">
                    <div className="row mb-4">
                        <div className="col-12">
                            <h3 className="mb-1">{title}</h3>
                            <p className="text-muted">{subtitle}</p>
                        </div>
                    </div>

                    {loading && (
                        <div className="text-center py-5">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    )}

                    {!loading && error && (
                        <div className="alert alert-danger">{error}</div>
                    )}

                    {!loading && !error && children}
                </div>
            </div>
            <DashboardFooter/>
        </div>
    </>
);

export default DashboardShell;
